import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import Loader1 from '../../assest/Loader-1.png';
import Loader2 from '../../assest/Loader-2.png';
import Loader3 from '../../assest/Loader-3.jpg';

// Sample translations with complete equipment data for each language
const translations = {
  gb: {
    heading: "Light Equipment",
    introText: "These are compact machines designed for efficient use in small spaces.",
    categoriesTitle: "Models Available",
    featuredTitle: "Highlighted Equipment",
    featuredDescription: "Our top picks for light-duty work.",
    equipmentList: [
      {
        name: "Mini Excavator",
        specs: "Small and powerful.",
        description: "Perfect for tight spaces and light digging work.",
      },
      {
        name: "Skid Steer Loader",
        specs: "Compact and versatile.",
        description: "Ideal for landscaping and small construction tasks.",
      },
      {
        name: "Compact Track Loader",
        specs: "Stable and smooth ride.",
        description: "Best for delicate surfaces and uneven terrain.",
      },
    ],
    specsLabel: "Specs:"
  },
  sa: {
    heading: "المعدات الخفيفة",
    introText: "آلات مدمجة مصممة للاستخدام الفعال في المساحات الصغيرة.",
    categoriesTitle: "النماذج المتاحة",
    featuredTitle: "المعدات المميزة",
    featuredDescription: "أفضل خياراتنا للأعمال الخفيفة.",
    equipmentList: [
      {
        name: "حفارة صغيرة",
        specs: "صغيرة الحجم وقوية.",
        description: "مثالية للمساحات الضيقة وأعمال الحفر الخفيفة.",
      },
      {
        name: "لودر انزلاقي التوجيه",
        specs: "مدمج ومتعدد الاستخدامات.",
        description: "مثالي لأعمال تنسيق المواقع والمهام الإنشائية الصغيرة.",
      },
      {
        name: "لودر مزود بجنزير",
        specs: "قيادة مستقرة وسلسة.",
        description: "الأفضل للأسطح الحساسة والتضاريس غير المستوية.",
      },
    ],
    specsLabel: "المواصفات:"
  },
  fr: {
    heading: "Équipement Léger",
    introText: "Machines compactes conçues pour une utilisation efficace dans les petits espaces.",
    categoriesTitle: "Modèles Disponibles",
    featuredTitle: "Équipement en Vedette",
    featuredDescription: "Nos meilleurs choix pour les travaux légers.",
    equipmentList: [
      {
        name: "Mini Pelle",
        specs: "Compacte et puissante.",
        description: "Parfaite pour les espaces restreints et les travaux de creusement légers.",
      },
      {
        name: "Chargeuse Compacte",
        specs: "Compacte et polyvalente.",
        description: "Idéale pour l'aménagement paysager et les petits travaux de construction.",
      },
      {
        name: "Chargeuse à Chenilles Compacte",
        specs: "Conduite stable et douce.",
        description: "Meilleur choix pour les surfaces délicates et les terrains accidentés.",
      },
    ],
    specsLabel: "Caractéristiques:"
  },
  de: {
    heading: "Leichte Ausrüstung",
    introText: "Kompakte Maschinen für den effizienten Einsatz in kleinen Räumen.",
    categoriesTitle: "Verfügbare Modelle",
    featuredTitle: "Hervorgehobene Ausrüstung",
    featuredDescription: "Unsere Top-Auswahl für leichte Arbeiten.",
    equipmentList: [
      {
        name: "Mini-Bagger",
        specs: "Klein und leistungsstark.",
        description: "Perfekt für enge Räume und leichte Grabearbeiten.",
      },
      {
        name: "Kompaktlader",
        specs: "Kompakt und vielseitig.",
        description: "Ideal für Landschaftsbau und kleine Bauaufgaben.",
      },
      {
        name: "Kompaktkettenlader",
        specs: "Stabile und sanfte Fahrt.",
        description: "Am besten für empfindliche Oberflächen und unebenes Gelände.",
      },
    ],
    specsLabel: "Spezifikationen:"
  }
};

const Loader = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={t.equipmentList.map((item, index) => ({
        ...item,
        image: [Loader1, Loader2, Loader3][index]
      }))}
      language={language}
    />
  );
};

export default Loader;